import { memo } from 'react';
import styled from '@emotion/styled';
import { Switch, Tooltip } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

interface Props {
  isSkippingAllPauses: boolean;
  onSkipPausesToggle: (arg0: boolean) => void;
}

const SwitchContainer = styled.div`
  display: inline-flex;
  span svg {
    opacity: 1;
  }
  // Need to change input size to match the switch,
  // as well as the z-index in order for the tooltip,
  // to display on hover
  input {
    width: 36px;
    height: 20px;
    z-index: 1;
  }
  label {
    display: flex;
    height: 24px;
  }
`;

const ToggleInactivitySwitchUnMemo = ({
  isSkippingAllPauses,
  onSkipPausesToggle,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Tooltip
      text={
        isSkippingAllPauses
          ? t('common:player.all-inactivity-skipped')
          : t('common:player.skip-all-inactivity')
      }
      placement="top"
    >
      <SwitchContainer>
        <Switch
          isChecked={isSkippingAllPauses}
          onChange={onSkipPausesToggle}
          iconName="fast_forward_alt"
        />
      </SwitchContainer>
    </Tooltip>
  );
};

export const ToggleInactivitySwitch = memo(ToggleInactivitySwitchUnMemo);
